import classNames from "classnames";
import { useEffect, useState } from "react";
import AscOptionsSelector from "../../components/AscOptionsSelector/AscOptionsSelector";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import { DEFAULT_USER_TYPES } from "../../lib/constants/default-user-types";
import AscAuthFlowLayout from "../AscAuthFlowLayout/AscAuthFlowLayout";
import styles from "./AscUserTypeSelectorView.module.scss";

export interface AscUserTypeSelectorViewProps {
  className?: string;
  userTypes?: typeof DEFAULT_USER_TYPES;
  onSelectUserType?: (userType: string) => void;
}

export default function AscUserTypeSelectorView({
  className,
  userTypes = DEFAULT_USER_TYPES,
  onSelectUserType,
}: AscUserTypeSelectorViewProps) {
  const [selectedUserType, setSelectedUserType] = useState("");

  useEffect(() => {
    if (selectedUserType) {
      onSelectUserType?.(selectedUserType);
    }
  }, [onSelectUserType, selectedUserType]);

  return (
    <AscAuthFlowLayout alignment="right" roundSideImage>
      <div
        data-testid="asc-user-type-selector-view"
        className={classNames(styles.ground, className)}
      >
        <header className={styles.heading}>
          <AscHeading className={styles.title} level={1}>
            I am a...
          </AscHeading>
          <AscParagraph className={styles.subTitle}>
            Please help us understand which platform option is best for you!
          </AscParagraph>
        </header>

        <AscOptionsSelector
          value={selectedUserType}
          onChange={setSelectedUserType}
        >
          {userTypes.map((userType) => (
            <AscOptionsSelector.Option
              key={userType?.value}
              label={userType.label}
              value={userType.value}
              icon={userType.icon}
            />
          ))}
        </AscOptionsSelector>
      </div>
    </AscAuthFlowLayout>
  );
}
